"use strict";

import Vue from "vue";
import dataAccessOpencms from "./dataAccessOpencms.js";

/**
 * Ofrece los métodos mismos métodos para acceder a datos independientemente del servidor a que acceda
 * Desacopla el código del framework y de la aplicaciones de cómo se acceden a los datos
 * @type {Object}
 */
const dataAccess = new Vue({
  // (se crea como componente Vue para que tenga acceso a toda la funcionalidad del framework,
  // p.e. $mdApp.utils, $log...)
  data: {
    /**
     * Implementación por defecto que se toma para el acceso a datos
     * (se ha puesto uno defecto para dejar la posibilidad de añadir más configuraciones por si
     * en el futuro se necesita acceder a distintos servidores de acceso a datos)
     * @type {Object}
     */
    defaultDataAccessImpl: null,
    /**
     * Configuraciones predefinidas
     * Sirve para reutilizar configuraciones como por ejemplo de producción, y por si alguna vez hay que cambiar una
     * configuración de producción, sólo habría que actualizar el framework y todas las aplicaciones funcionarian
     * con la nueva configuración
     * @type {Object}
     */
    predefinedConfigs: {
      /**
       * Implementación para el servidor de producción de opencms para las webs
       * @type {Object}
       */
      opencmsWebProd: {
        host: "",
        basePath: "/avra/opencms/",
        additionalPath: "catalogo-inmuebles",
        serverImpl: dataAccessOpencms,
        cmsPageDataQueryParam: "resource=page-data",
        cmsResourcesNoPagesPath: "recursos-propios",
        cmsResourcesNoPagesPathSuffix: ".json",
        cmsResourceRoutes: "web-routes"
      },
      opencmsWebOferta: {
        host: "http://ws04.avra.junta-andalucia.es",
        // host: 'http://www.juntadeandalucia.es',
        basePath: "/avra/opencms/",
        additionalPath: "",
        serverImpl: dataAccessOpencms,
        cmsPageDataQueryParam: "resource=page-data",
        cmsResourcesNoPagesPath: "recursos-propios",
        cmsResourcesNoPagesPathSuffix: ".json",
        cmsResourceRoutes: "web-routes"
      },
      opencmsWebDevjda: {
        // host: 'http://ws03.epsa.junta-andalucia.es',
        host: "http://www.juntadeandalucia.es",
        basePath: "/avra/",
        additionalPath: "",
        serverImpl: dataAccessOpencms,
        cmsPageDataQueryParam: "resource=page-data",
        cmsResourcesNoPagesPath: "recursos-propios",
        cmsResourcesNoPagesPathSuffix: ".json",
        cmsResourceRoutes: "web-routes"
      },
      opencmsWebDevjdaWithLocalhostProxy: {
        host: "",
        basePath: "/avra/opencms/",
        additionalPath: "",
        serverImpl: dataAccessOpencms,
        cmsPageDataQueryParam: "resource=page-data",
        cmsResourcesNoPagesPath: "recursos-propios",
        cmsResourcesNoPagesPathSuffix: ".json",
        cmsResourceRoutes: "web-routes"
      },
      opencmsWebDev: {
        host: "http://aguadulcedev.epsa.junta-andalucia.es:8080",
        basePath: "/avra/opencms/",
        additionalPath: "",
        serverImpl: dataAccessOpencms,
        cmsPageDataQueryParam: "resource=page-data",
        cmsResourcesNoPagesPath: "recursos-propios",
        cmsResourcesNoPagesPathSuffix: ".json",
        cmsResourceRoutes: "web-routes"
      }
    }
  },
  methods: {
    /**
     * Crea un elemento en el servidor de datos
     * @param  {[type]} itemResourcePath Nombre o Path de los recursos donde crear uno nuevo
     * @param  {[type]} data             datos del nuevo elemento
     * @return {[type]}                  Devuelve una promesa de axios
     */
    createItem(itemResourcePath, data) {
      var response = null;

      // this.$mdApp.log.debug('dataAccess: readList: petición enviada: itemResourcePath', itemResourcePath);
      // this.$mdApp.log.debug('dataAccess: readList: petición enviada: options', options);
      response = this.defaultDataAccessImpl.createItem(itemResourcePath, data);
      // this.$mdApp.log.debug('dataAccess: readList: respuesta recibida:', response);
      return response;
    },
    /**
     * Lee un elemento de un servidor de acceso de datos
     * @param  {[type]}  itemResourcePath       Nombre o Path del recurso o elemento a leer
     * @return {[type]}                         Devuelve una promesa de axios
     */
    readItemByResourcePath(itemResourcePath) {
      var response = null;

      // lo delegamos en la implementación correspondiente
      this.$mdApp.log.debug(
        "dataAccess: readItemByResourcePath: petición enviada: itemResourcePath:",
        itemResourcePath
      );
      response = this.defaultDataAccessImpl.readItemByResourcePath(
        itemResourcePath
      );
      this.$mdApp.log.debug(
        "dataAccess: readItemByResourcePath: respuesta recibida:",
        response
      );
      return response;
    },
    /**
     * Lee un elemento de un servidor de acceso de datos no por su id sino por un conjunto de terminos de filtrado, que deben
     * de devolver un unoico elemento (lo hacemos así porque a vecs en base de datos no hay un id claro, no debería pero... )
     * @param  {[type]}  itemResourcePath   Nombre o Path del recurso o elemento a leer
     * @param  {[type]}  filterTerms        terminos de filtrado de la forma {field1: ''}
     * @return {[type]}                     Devuelve una promesa de axios
     */
    readItemByFilterTerms(itemResourcePath, filterTerms) {
      var response = null;

      // lo delegamos en la implementación correspondiente
      this.$mdApp.log.debug(
        "dataAccess: readItemByFilterTerms: petición enviada: itemResourcePath:",
        itemResourcePath,
        "filterTerms",
        filterTerms
      );
      response = this.defaultDataAccessImpl.readItemByFilterTerms(
        itemResourcePath,
        filterTerms
      );
      this.$mdApp.log.debug(
        "dataAccess: readItemByFilterTerms: respuesta recibida:",
        response
      );
      return response;
    },
    /**
     * Para leer los routes dinamicamente. Puede que no este implementado en algunos serverImpl
     * @return {[type]} Promesa axios con la respuesta de la petición
     */
    readCmsRoutes() {
      var response = null;

      if (this.defaultDataAccessImpl.readCmsRoutes) {
        this.$mdApp.log.debug("dataAccess: readCmsRoutes: petición enviada");
        response = this.defaultDataAccessImpl.readCmsRoutes();
        this.$mdApp.log.debug(
          "dataAccess: readCmsRoutes: respuesta recibida:",
          response
        );
        return response;
      }

      // this.$log.error('dataAccess: readCmsRoutes: se ha solicitado pero esta implementación no tiene definido este método');
      return response;
    },
    /**
     * Lee los datos de una página del cms
     * @param  {[type]} routePath path de la página según esté puesta en routes (suele ser relativo al directorio de la web)
     * @return {[type]} Promesa axios con la respuesta de la petición
     */
    readCmsPageDataByRoutePath(routePath) {
      var response = null;

      if (this.defaultDataAccessImpl.readCmsRoutes) {
        this.$mdApp.log.debug(
          "dataAccess: readCmsPageDataByRoutePath: petición enviada:",
          routePath
        );
        response = this.defaultDataAccessImpl.readCmsPageDataByRoutePath(
          routePath
        );
        this.$mdApp.log.debug(
          "dataAccess: readCmsPageDataByRoutePath: respuesta recibida:",
          response
        );
        return response;
      }

      // this.$log.error('dataAccess: readCmsPageDataByRoutePath: se ha solicitado pero esta implementación no tiene definido este metodo');
      return response;
    },
    /**
     * Devuelve un listado del recurso indicado, según las opciones pasadas
     * @param  {[type]} itemResourcePath path del recurso que se quiere obtener un listado, p.e. actuaciones
     * @param  {[type]} options          [description]
     * @return {[type]}                  [description]
     */
    readList(itemResourcePath, options) {
      var response = null;

      this.$mdApp.log.debug(
        "dataAccess: readList: petición enviada: itemResourcePath:",
        itemResourcePath,
        ", options: ",
        options
      );
      response = this.defaultDataAccessImpl.readList(itemResourcePath, options);
      this.$mdApp.log.debug(
        "dataAccess: readList: respuesta recibida:",
        response
      );
      return response;
    },
    /**
     * Establece la configuración por defecto con la que se accederán a los datos desde el framework
     * @param {[type]} config Configuración que se va a establecer por defecto
     */
    setDefaultConfig(config) {
      // Actualizamos lo primero la implementacion del dataaccess
      this.defaultDataAccessImpl = config.serverImpl;
      // Actualizamos la configuracion de la implementación correspondiente
      // (quitamos la propiedad serverImpl para que no sea recursivo)
      delete config.serverImpl;
      this.defaultDataAccessImpl.config = this.$mdApp.utils.cloneObject(config);
    },
    /**
     * Traduce las urls que pone el cms para ir a una pagina en formato del route, que es lo que entiende vuejs
     * @return {[type]} [description]
     */
    translateCmsUrl2RouterPath(cmsUrl) {
      if (this.defaultDataAccessImpl.translateCmsUrl2RouterPath) {
        return this.defaultDataAccessImpl.translateCmsUrl2RouterPath(cmsUrl);
      }

      // this.$log.error('dataAccess: translateCmsUrl2RouterPath: se ha solicitado pero esta implementación no tiene definido este metodo');
      return null;
    },
    /**
     * Traduce las urls que pone el cms en absoluta, para que desde el html, p.e. se puedan referenciar imágenes
     * @param  {[type]} cmsUrl [description]
     * @return {[type]}        [description]
     */
    translateCmsUrl2AbsoluteUrl(cmsUrl) {
      if (this.defaultDataAccessImpl.translateCmsUrl2AbsoluteUrl) {
        return this.defaultDataAccessImpl.translateCmsUrl2AbsoluteUrl(cmsUrl);
      }

      // this.$log.error('dataAccess: translateCmsUrl2AbsoluteUrl: se ha solicitado pero esta implementación no tiene definido este metodo');
      return null;
    },
    /**
     * Enruta hacia una ruta tal como te la da el cms
     * @param cmsPath {String} cadena que usa cms
     */
    routeToCmsPath(router, cmsPath) {
      var path = this.translateCmsUrl2RouterPath(cmsPath);

      router.push({ path: path });
    }
  }
});

export default dataAccess;
